import { factory } from "../../../../utils/apiThunkFactory";

export const getActiveUsers = factory.get("interactModal/getActiveUsers", "/api/users/online");


export const joinRoom = factory.post("interactModal/joinRoom", "/api/placement/room");


export const getConnectedUsers = factory.get("interactModal/getConnectedUsers", "/api/users/connected");
